import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { useTheme } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import { useNavigate } from "react-router-dom";
import { useForm, FormContainer, FormErrorProvider } from "react-hook-form-mui";
import { BoxContainer, CustomTextFieldElement } from "../layouts/Theme";
import { useI18N } from "../context/I18NContext";
import { useReminder } from "../hooks/query/useReminder";
export default function PasswordReminder({ bookingCore, onBackToSignin }) {
    const { t } = useI18N();
    const theme = useTheme();
    const navigate = useNavigate();
    const [reminded, setReminded] = useState(false);
    const [reminding, setReminding] = useState(false);
    const formContextReminder = useForm({});
    const onSubmit = (data, event) => {
        // console.log(formContextReminder.getValues())
        reminderQuery.refetch();
        setReminding(true);
    };
    const onError = (errors) => { };
    const reminderQuery = useReminder(formContextReminder);
    useEffect(() => {
        if (reminderQuery.data) {
            setReminding(false);
            if (reminderQuery.data.status === 'OK') {
                setReminded(true);
            }
        }
    }, [reminderQuery.data]);
    const toSignin = () => {
        if (bookingCore) {
            // in a skin the sign-in form is a sub-step of the same step, not a route
            onBackToSignin === null || onBackToSignin === void 0 ? void 0 : onBackToSignin();
            return;
        }
        navigate(`/oa_widget_signIn`);
    };
    const body = (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", sx: { color: theme.palette.text.primary }, children: t('Wachtwoord of gebruikersnaam vergeten?') }), !reminded && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body1", sx: { my: 1, color: theme.palette.text.primary }, children: t('Weet je het wachtwoord of je gebruikersnaam niet meer? Vul hieronder je e-mailadres in. We sturen dan binnen enkele minuten een e-mail waarmee een nieuw wachtwoord kan worden aangemaakt.') }), _jsx(FormContainer, { formContext: formContextReminder, onSuccess: onSubmit, onError: onError, children: _jsxs(FormErrorProvider, { onError: (error) => {
                                if (error.type === 'validate') {
                                    console.log(error);
                                }
                                return t(error.type, 'error');
                            }, children: [_jsx(CustomTextFieldElement, { required: true, label: t('E-mail adres'), name: 'email', type: "email", InputProps: {
                                        startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(EmailIcon, { sx: { color: theme.palette.text.secondary } }) }))
                                    }, sx: { my: 2 }, fullWidth: true }), _jsx(Button, { type: "submit", disabled: reminding, fullWidth: true, sx: { my: 1 }, variant: "contained", children: t('Verzenden') })] }) })] })), !reminding && reminded && (_jsxs(_Fragment, { children: [_jsx(Alert, { sx: { my: 1 }, severity: "success", children: t('Als je e-mailadres voorkomt in ons systeem, is er een e-mail verzonden met instructies om je wachtwoord opnieuw in te stellen.') }), _jsxs(Typography, { variant: "body1", sx: { my: 1, color: theme.palette.text.primary }, children: [t('E-mail adres'), ": ", formContextReminder.getValues('email')] }), _jsx(Typography, { variant: "body1", sx: { my: 1, color: theme.palette.text.primary }, children: t('Heb je geen e-mail ontvangen? Controleer de spamfolder en het e-mailadres wat is ingevoerd.') }), _jsx(Button, { type: "button", onClick: toSignin, fullWidth: true, sx: { my: 1 }, variant: "contained", children: t('Terug naar inloggen') })] }))] }));
    // a skin brings its own container and styling, so skip the widget's BoxContainer
    return bookingCore ? body : _jsx(BoxContainer, { children: body });
}
